import type { TowerDesign } from "@/game/towerSpec";
/**
 * South Africa telecom guyed tower — from the structural-analysis drawing in
 * reference_towers/02_engineering_drawings/ZA_structural_analysis_telecom_tower_drawing.pdf.
 * A triangular guyed steel lattice telecom tower (SANS 10160 design). Overall
 * height and exact member/guy schedule not fully text-extractable from the
 * drawing → a representative ~60 m triangular guyed mast (flagged as approximate).
 */
export const design: TowerDesign = {
  id: "guyed-za-telecom",
  name: "Guyed Mast (South Africa telecom)",
  description: "SA telecom triangular guyed lattice tower (~60 m, SANS 10160). Approximated.",
  author: "reference: ZA structural analysis telecom tower drawing",
  spec: {
    type: "guyed",
    height: 60,
    stack: { faces: 3, panels: 30, baseRadius: 0.6, topRadius: 0.6,
      legSection: "legHeavy", braceSection: "braceHeavy", legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: [0.3, 0.55, 0.8, 0.96].map((f, i) => ({ atHeightFrac: f, anchorRadius: 24 + i * 8, section: "guy38", material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "dense-sand", base: { type: "pier", width: 0.6, diameter: 0.6, depth: 1.5, concrete: "c25" }, anchor: { type: "deadman", width: 1.5, diameter: 0.6, depth: 2, concrete: "c25" } },
  },
};
